<template>
  <div
    class="fixed top-0 left-0 w-full h-full flex flex-col items-center justify-center bg-white text-center z-[999999] backdrop-blur p-4 overflow-y-auto"
  >
    <header class="fixed top-0 left-0 w-full bg-white border-b border-gray-300 py-3 flex items-center justify-center">
      <img
        src="@/assets/logo.svg"
        alt="Energielenker Connect"
        class="max-w-[300px] cursor-pointer"
        @click="goToHome"
      >
    </header>

    <div class="mt-20 max-w-[320px]">
      <p class="font-bold mb-3">
        {{ $t('offline.headline') }}
      </p>

      <p class="font-normal text-base mb-4 px-3">
        {{ $t('offline.message') }}
      </p>

      <img
        src="@/assets/icons/maintenance.svg"
        alt="Wartung"
        class="max-w-[300px] mb-4"
      >

     
      <Button
        icon="pi pi-refresh"
        :label="$t('common.reload')"
        class="bg-[#7190a6] text-white border border-[#325f80] py-3.5 px-8 text-base rounded w-[300px] flex items-center justify-center mx-auto transition-colors duration-200 hover:bg-[#eef2f4] hover:text-[#325f80]"
        :loading="isLoading"
        @click="reloadPage"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useSystemStore } from '@/stores/systemStore';
import apiClient from '@/services/axios';
import Button from 'primevue/button';

export default defineComponent({
  name: 'OfflineModeComponent',
  components: {
    Button,
  },
  setup() {
    const router = useRouter();
    const systemStore = useSystemStore();
    const isLoading = ref(false);
    async function pingBackend(): Promise<boolean> {
      try {
        await apiClient.get('/'); 
          return true;
      } catch {
          return false;
      }
    }
    const reloadPage = async () => {
      isLoading.value = true;
      const isBackendUp = await pingBackend();
      if (isBackendUp) {
        systemStore.deactivateMaintenance();
      } else {
        console.warn('Backend still down');
      }
      isLoading.value = false;
    };

    const goToHome = () => {
      systemStore.deactivateMaintenance();
      router.push('/home');
    };

    return { 
      reloadPage,
      goToHome,
      isLoading
    };
  },
});
</script>

<style scoped>
.offline-mode {
  z-index: 999999;
  backdrop-filter: blur(4px);
  padding: 1rem;
  overflow-y: auto;
}

.offline-header {
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
  border-bottom: 1px solid #e0e3e5;
  padding: 1.25rem 0;
  text-align: center;
}

.offline-logo-header {
  max-width: 300px;
}

.offline-content {
  margin-top: 5rem;
  max-width: 320px;
}

.offline-img {
  max-width: 300px;
}

.btn-reload {
  background-color: #7190a6;
  color: #fff;
  border: none;
  padding: 0.875rem 2rem;
  font-size: 1rem;
  border-radius: 4px;
  cursor: pointer;
  width: 300px;
  transition: background-color 0.2s ease;
  border: #325f80 1px solid;
}

.btn-reload:hover {
    background: #eef2f4;
    border: #325f80 1px solid;
    color: rgb(50, 95, 128);
    .reload-icon {
    filter: brightness(0) saturate(100%) invert(53%) sepia(20%) saturate(542%) hue-rotate(162deg) brightness(100%) contrast(84%);
    }
}

.reload-icon {
  width: 1.2rem;
}

.lead{
    font-weight: 400;
    font-size: 1rem;
}
</style>
